export const theme = {
  colors: {
    primary: '#FE5459',      // 赤ピンク（メインカラー）
    secondary: '#4ECDC4',    // ターコイズブルー
    accent: '#FFD93D',       // 黄色
    beige: '#F5E6D3',        // ベージュ背景
    lightBlue: '#E8F6FF',    // 薄い青背景
    white: '#FFFFFF',
    gray: {
      light: '#F6F2E7',
      medium: '#E8E5E4',
      dark: '#7E6E66'
    },
    text: {
      primary: '#2D3436',
      secondary: '#636E72',
      light: '#B2BEC3'
    }
  },
  fonts: {
    main: '"Hiragino Kaku Gothic ProW3", "Noto Sans JP", "Hiragino Kaku Gothic ProN", "メイリオ", sans-serif',
    heading: '"Hiragino Kaku Gothic ProW3", "M PLUS Rounded 1c", "Hiragino Maru Gothic ProN", sans-serif',
    game: '"Hiragino Kaku Gothic ProW3", "M PLUS Rounded 1c", sans-serif'
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    xxxl: '64px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
    full: '50%'
  },
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.08)',
    md: '0 4px 12px rgba(0, 0, 0, 0.12)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.16)',
    xl: '0 12px 32px rgba(0, 0, 0, 0.20)'
  }
};

export type Theme = typeof theme;